
import Loading from 'assets/elements/jean-loading.svg?react';

export function LoadingScreen() {
    return <Loading />
}